// Iconos de trazo (24×24) con la misma línea redondeada para toda la parte privada. Decorativos: llevan aria-hidden.
const TRAZOS = {
  pin: "M12 21s-7-5.2-7-11a7 7 0 1114 0c0 5.8-7 11-7 11zM12 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
  camara: "M4 8h3l1.5-2h7L17 8h3v11H4zM12 17a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
  qr: "M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 14h2v2h-2zM14 18h2v2h-2zM18 18h2v2h-2z",
  reloj: "M12 21a9 9 0 100-18 9 9 0 000 18zM12 7v5l3 2",
  check: "M5 13l4 4L19 7",
  checkCirculo: "M12 21a9 9 0 100-18 9 9 0 000 18zM8 12.5l2.7 2.7L16 9.5",
  alerta: "M12 3l10 18H2zM12 10v4M12 17.5h.01",
  escudo: "M12 3l8 3v6c0 4.5-3.2 7.8-8 9-4.8-1.2-8-4.5-8-9V6zM9 12l2.2 2.2L15.5 10",
  repetir: "M20 11a8 8 0 10-2.3 5.7M20 4v7h-7",
  mapa: "M9 4l6 2 5-2v14l-5 2-6-2-5 2V6zM9 4v14M15 6v14",
  usuario: "M12 12a4 4 0 100-8 4 4 0 000 8zM4 21a8 8 0 0116 0",
  candado: "M6 11h12v9H6zM8.5 11V8a3.5 3.5 0 017 0v3",
  salir: "M10 4H5v16h5M15 8l4 4-4 4M19 12H9",
  casa: "M3 11l9-7 9 7M5 10v10h5v-6h4v6h5V10",
  panel: "M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z",
  vender: "M4 5h2l2 10h10l2-7H7M10 20a1 1 0 100-2 1 1 0 000 2zM17 20a1 1 0 100-2 1 1 0 000 2z",
  camion: "M3 6h11v9H3zM14 9h4l3 3v3h-7M7 19a2 2 0 100-4 2 2 0 000 4zM17 19a2 2 0 100-4 2 2 0 000 4z",
  dinero: "M3 7h18v10H3zM12 14.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM6.5 10h.01M17.5 14h.01",
  ajustes: "M4 7h10M18 7h2M4 17h2M10 17h10M16 4v6M8 14v6",
  llave: "M14 10a4 4 0 11-1.2-2.8L21 15v3h-3v-2h-2v-2h-2.2M8 10h.01",
  externo: "M14 4h6v6M20 4l-9 9M18 13v6H5V6h6",
  agencia: "M3 21V8l9-5 9 5v13M9 21v-6h6v6",
  cerrar: "M6 6l12 12M18 6L6 18",
  flecha: "M5 12h14M13 6l6 6-6 6",
  flechaEntrada: "M7 17L17 7M9 7h8v8",
  flechaSalida: "M17 7L7 17M15 17H7V9",
  ojo: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM12 15a3 3 0 100-6 3 3 0 000 6z",
  senal: "M5 19h.01M8.5 15.5a5 5 0 017 0M5 12a10 10 0 0114 0",
  lista: "M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01",
  mas: "M12 5v14M5 12h14",
  ayuda: "M12 21a9 9 0 100-18 9 9 0 000 18zM9.5 9.5a2.6 2.6 0 015 .9c0 1.7-2.5 2.2-2.5 3.6M12 17h.01",
  estrella: "M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z",
  montana: "M3 20l6-10 4 6 3-4 5 8z",
  calendario: "M4 6h16v14H4zM4 10h16M8 3v4M16 3v4",
  grupo: "M9 11a3 3 0 100-6 3 3 0 000 6zM3 20a6 6 0 0112 0M16 5a3 3 0 010 6M21 20a6 6 0 00-4-5.6",
  cama: "M3 18v-6a2 2 0 012-2h14a2 2 0 012 2v6M3 15h18M7 10V7h4v3",
  pino: "M12 3l5 7h-3l4 6h-5v5h-2v-5H6l4-6H7z",
  carrito: "M3 4h2l2.4 11h11l2-8H6.3M10 20h.01M17 20h.01",
  herradura: "M7 20H5V11a7 7 0 0114 0v9h-2M7 20v-9a5 5 0 0110 0v9M8.5 13h.01M15.5 13h.01",
  luna: "M20 14.5A8 8 0 019.5 4 8 8 0 1020 14.5z",
  helice: "M3 7h18M12 7v3M5 13a7 3 0 0014 0 7 3 0 00-14 0zM19 13h2M7 18l-1 2M17 18l1 2",
  filtro: "M4 5h16l-6 8v6l-4-2v-4z",
  menos: "M5 12h14",
  humo: "M4 12h12v4H4zM18 12v4M21 12v4M4 4l16 16",
  sol: "M12 16a4 4 0 100-8 4 4 0 000 8zM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4",
  atardecer: "M3 18h18M6 18a6 6 0 0112 0M12 6v3M5.6 9.6l1.5 1.5M18.4 9.6l-1.5 1.5M2 14h2M20 14h2M8 22h8",
  asiento: "M7 4h6a2 2 0 012 2v7H7zM5 13h12a2 2 0 012 2v2H5zM7 17v4M17 17v4",
  editar: "M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4",
  huella: "M7.5 5.2A8 8 0 0120 12v1M4.2 9A8 8 0 004 11v2M8 20.5A13 13 0 017 15v-3a5 5 0 0110 0v1.5M12 12v3.5a9 9 0 001.6 5M16.6 17.5a14 14 0 01-.6 3.2M12 16a12 12 0 00-1.2-.1",
  correo: "M3 6h18v12H3zM3 7l9 6 9-6",
  telefono: "M6 3h3l1.5 5-2 1.3a11 11 0 006.2 6.2l1.3-2L21 15v3a2 2 0 01-2 2A16 16 0 014 5a2 2 0 012-2z",
  mensaje: "M20 12a8 8 0 01-11.6 7.1L4 20l1-4.2A8 8 0 1120 12zM9 10.5c.5 1.8 2 3.3 4 4l1.2-1.1 1.8.8",
  tienda: "M4 9l1.5-5h13L20 9M4 9h16M4 9v11h16V9M9 20v-6h6v6",
  basura: "M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3",
} as const;
export type NombreIcono = keyof typeof TRAZOS;

export function Icono({ nombre, tam = 22, trazo = 2 }: { nombre: NombreIcono; tam?: number; trazo?: number }) {
  return <svg className="sis-icono" viewBox="0 0 24 24" width={tam} height={tam} fill="none" stroke="currentColor" strokeWidth={trazo} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d={TRAZOS[nombre]} /></svg>;
}
